<template>
    <div>
        <div v-if="$vuetify.breakpoint.xsOnly">
            <v-row v-for="item in object.data" :key="item.id">
                <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <v-card
                        outlined
                        class="pa-2"
                    >
                        <v-row dense>
                            <v-col class="text-left" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                <span>
                                    <v-chip
                                        label
                                        small
                                        color="blue lighten-5" 
                                    >
                                    <span style="font-size:12px">{{ item.codigo }}</span> 
                                    </v-chip>   
                                </span>
                                <span class="ml-2">
                                    <v-chip
                                        :color="item.status | statusUserRequest"
                                        label
                                        small
                                    >
                                        {{ item.status }}
                                    </v-chip> 
                                </span>
                            </v-col>  
                        </v-row>

                        <v-row dense class="mt-3 pa-2">
                            <v-col class="text-left" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                <div :class="$css_show_description">
                                    <span :class="$css_show_title">Assunto:</span>
                                    {{ item.subject }}
                                    <div v-if="item.object && item.object.length > 0">
                                        CODIGO: {{ item.object[0].codigo }}
                                        - {{ item.object[0].endereco }}
                                        <span v-if="item.object[0].numero && item.object[0].numero > 0">, {{ item.object[0].numero }}</span>
                                        <span v-if="item.object[0].apartamento && item.object[0].apartamento > 0"> apto {{ item.object[0].apartamento }}</span>
                                    </div>
                                </div> 
                            </v-col>
                            <v-col class="text-left" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                <div :class="$css_show_description">
                                    <span :class="$css_show_title">Solicitante:</span> 
                                    {{ item.name_user_request }}
                                </div> 
                            </v-col>
                        </v-row>
                      

                        <v-row dense>
                            <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                <v-card-actions class="text-right"> 
                                    <v-spacer></v-spacer>
                                    <!--v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn icon @click.prevent="showItem(item.id)" class="ml-8">
                                                <v-icon v-bind="attrs" v-on="on">mdi-eye</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Visualizar</span>
                                    </v-tooltip-->
                                    
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn icon @click.prevent="editItem(item.id)" class="ml-8">
                                                <v-icon v-bind="attrs" v-on="on">mdi-pencil</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Editar</span>
                                    </v-tooltip>

                                    <v-tooltip top  v-if="me.profile == 'Master' || me.profile == 'Gerente'">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn icon @click.prevent="confirmDestroy(item)" class="ml-8">
                                                <v-icon v-bind="attrs" v-on="on">mdi-delete</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Delete</span>
                                    </v-tooltip>
                                </v-card-actions>  
                            </v-col>    
                        </v-row>

                    </v-card>
                </v-col>    
            </v-row>

            <v-row v-if="object.meta && object.meta.total > 0">
                <v-col cols="6" xs="6" sm="6" md="6" lg="6" xl="6">
                    <v-btn
                        v-if="object.meta.to > 1 && object.meta.total > this.options.itemsPerPage"
                        depressed
                        class="mt-2 mb-3" 
                        color="error"
                        @click="linkPagination(object.meta.to - 1)"
                        block
                    >
                        <v-icon left>
                            mdi-skip-previous
                        </v-icon>
                        Anterior
                    </v-btn>
                </v-col>
                <v-col cols="6" xs="6" sm="6" md="6" lg="6" xl="6">
                    <v-btn
                        v-if="object.meta.to < object.meta.total"
                        depressed
                        color="primary"
                        class="mt-2 mb-3"
                        @click="linkPagination(object.meta.to + 1)"
                        block
                    >
                        Próximo
                        <v-icon left class="ma-1">
                            mdi-skip-next
                        </v-icon>
                    </v-btn>
                </v-col>    
            </v-row>
        </div>


        <v-row class="mt-4" v-else>
            <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <v-card
                    class="mx-auto"
                    outlined
                >
                
                <v-data-table
                    :headers="headers"
                    :items="object.data"
                    :options.sync="options"
                    :server-items-length="object.meta && object.meta.total"
                    class="elevation-1 table-striped caption"
                    :footer-props="{    
                        'items-per-page-text':'Itens por página',
                        'items-per-page-options': [5, 10],
                        'items-per-page-all-text': '',
                        'page-text': '{0}-{1} de {2}'
                    }"
                >
                    
                    
                    <template v-slot:[`item.status`]="{ item }">
                        <v-chip
                            :color="item.status | statusUserRequest"
                            label
                            small
                            :class="$css_report_list"
                        >
                            {{ item.status }}
                        </v-chip> 
                    </template>


                    <template v-slot:[`item.codigo`]="{ item }">
                        <v-chip
                            label
                            small
                            color="blue lighten-5" 
                        >
                            <span style="font-size:12px">{{ item.codigo }}</span> 
                        </v-chip> 
                    </template>

                    <template v-slot:[`item.subject`]="{ item }">
                        <div class="font-weight-bold">{{ item.subject }}</div>
                        <div v-if="item.object && item.object.length > 0">
                            CODIGO: {{ item.object[0].codigo }}
                            - {{ item.object[0].endereco }}
                            <span v-if="item.object[0].numero && item.object[0].numero > 0">, {{ item.object[0].numero }}</span>
                            <span v-if="item.object[0].apartamento && item.object[0].apartamento > 0"> apto {{ item.object[0].apartamento }}</span>
                        </div>
                    </template>
                    
                   
                    <template v-slot:[`item.actions`]="{ item }">
                        <v-card-actions>
                            <!--v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn icon @click.prevent="showItem(item.id)" class="ml-2">
                                        <v-icon v-bind="attrs" v-on="on">mdi-eye</v-icon>
                                    </v-btn>
                                </template>
                                <span>Visualizar</span>
                            </v-tooltip-->

                            <span v-if="me.profile == 'Master' || me.profile == 'Gerente'">
                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn icon @click.prevent="editItem(item.id)" class="ml-8">
                                            <v-icon v-bind="attrs" v-on="on">mdi-pencil</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Editar</span>
                                </v-tooltip>

                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn icon @click.prevent="confirmDestroy(item)" class="ml-8">
                                            <v-icon v-bind="attrs" v-on="on">mdi-delete</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Delete</span>
                                </v-tooltip>
                            </span>
                        </v-card-actions>     
                    </template> 
                </v-data-table>
               
                </v-card>
            </v-col>
        </v-row>

    </div>
</template>

<script>
import CarouselComponent from '../../carousel/CarouselComponent.vue'

export default {

    components: {
        CarouselComponent
    },

    props: {
        object: {},

        filters: {},
    }, 

    watch: {
        options: {
            handler() {
                if(this.options.page >= 1){
                    this.loadItems();
                }   
            },
        },

        filters () {
            this.options.page = 1
        },

    },

    computed: {
        me () {
          return this.$store.state.auth.me
        },
    }, 

    data () {
        return {
            dialog_carousel: false,
            item: {},

            options: {
                page: 1,
                itemsPerPage: 10,
            },

            headers: [
                { text: 'CODIGO', value: 'codigo' , sortable: false}, 
                { text: 'STATUS', value: 'status' , sortable: false},  
                { text: 'ASSUNTO', value: 'subject' , sortable: false},  
                { text: 'SOLICITANTE', value: 'name_user_request' , sortable: false},
                { text: 'GERENTE', value: 'name_user_manager' , sortable: false},
                { text: 'AÇÕES', value: 'actions', sortable: false },
            ],

            confirmDelete: {
                id: '',
                status: false,
                name: '',
                text: '',
                destroyfunction: '',
            },
        }    
    },

    filters: {
        userProfileColor (value) {
            if(!value) return ''
            if(value == 'Gerente') return 'blue lighten-4'
            else if(value == 'Master') return 'orange lighten-4'
            else if(value == 'Corretor') return 'green lighten-4'
            else return ''
        },
    },

    methods: {
        loadItems(){
            this.params = this.filters 
            this.params.page = this.options.page
            if(this.options.itemsPerPage && this.options.itemsPerPage > 0){
                this.params.paginate = this.options.itemsPerPage
            }
            this.$emit('callLoadItems', this.params)   
        },

        openCloseDialog() {
            this.dialog = !this.dialog
        },

        editItem(id){
            this.$emit('callEditItem', id)
        },

        showItem(id){
            this.$emit('callShowItem', id)
        },

        confirmDestroy(item) {
            this.$snotify.error(`Tem certeza que deseja excluir esse registro?`, 'Confirmaçāo', {
                timeout: 10000,
                showProgressBar: true,
                closeоnClick: true,
                buttons: [
                    {text: 'Nāo', action: this.$snotify.remove()},
                    {text: 'Sim', action: () => {
                        this.destroy(item)
                        this.$snotify.remove()
                    }},
                ]
            })
        },

        destroy(item){
            this.$store.dispatch('destroyUserRequest', item.id)
                        .then(() => {
                            this.$snotify.success(`Registro excluído com sucesso`, 'Exclusāo')
                            this.$emit('callLoadItems')
                        })
                        .catch(error => {
                            this.$snotify.error('error', error)
                        })
        },

        linkPagination(page){
            this.options.page = page 
            this.loadItems();
        }
    },
}
</script>